import React from 'react';
import FirebaseCollectionPage from './FirebaseCollectionPage';
import { COLLECTION_PAGES } from '../../config/collectionPages';

const ContactsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.contacts} />
);

const ConversationsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.conversations} />
);

const BlocksManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.blocks} />
);

const FavoritesManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.favorites} />
);

const AlbumsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.albums} />
);

const TapsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.taps} />
);

const PresenceManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.presence} />
);

const ProfileCardsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.profileCards} />
);

const ProfileImageViewsManagement = () => (
  <FirebaseCollectionPage config={COLLECTION_PAGES.profileImageViews} />
);

export {
  ContactsManagement,
  ConversationsManagement,
  BlocksManagement,
  FavoritesManagement,
  AlbumsManagement,
  TapsManagement,
  PresenceManagement,
  ProfileCardsManagement,
  ProfileImageViewsManagement,
};
